<div class="menu-container">
  @if (category().length >= 1) {
    <div class="categories-grid">
      @for (cat of category(); track cat.categoryId) {

        <app-category-card [category]="cat" class="anim-fade-in-up"></app-category-card>
      }
    </div>
  } @else {
    <app-skeleton-categories/>
  }
</div>
